import {ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EmpresaEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class EmpresaDataService extends CrudService<EmpresaEntity>
{
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        protected httpClient: HttpClient
    )
    {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/empresa`;
    }

    public adicionar = (payload: EmpresaEntity) =>
        this.httpClient.post<ApiResult<string>>(`${this.url}/Solicitar`, payload );

}
